import { useQuery } from "@tanstack/react-query";

import { getSportProviders } from "@/api/settings/sportProviders";
import { SettingsQueryKeys } from "./settingsQueryKeys";

export const useSportProviders = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: [SettingsQueryKeys.SportProviders],
    queryFn: ({ signal }) => getSportProviders({ signal }),
    enabled: options?.enabled,
  });
};
